(ns ui.wallet.customer-conflict
  "Modal shown instead of the checkout when the organization has no Paddle
   customer because the user's email belongs to another organization's
   customer (`:paddle/customer-email-conflict?`, see
   `app.part/ensure-customer-id!`). Paddle allows one customer per email,
   so only the support can untangle it; the button opens the chat with a
   prefilled message."
  (:require [parts.replicant.query :as query]
            [storrito.ui.button :as button]
            [ui.subscription.core :as core]
            [ui.wallet.i18n :as i18n]))

(def modal-id
  :modals/wallet-customer-conflict)

(defn conflict?
  [w]
  (boolean (:paddle/customer-email-conflict?
            (query/get-result w core/subscription-query))))

(defn content
  []
  [:div.py-4.flex.flex-col.items-center.max-w-md.mx-auto.text-center
   [:div.w-16.h-16.rounded-full.bg-amber-100.flex.items-center.justify-center.mb-6
    [:i.fas.fa-exclamation-triangle.text-2xl.text-amber-600]]
   [:h3.text-lg.font-semibold.text-gray-900.mb-2
    [:i18n :customer-conflict/title]]
   [:p.text-sm.text-gray-500.mb-6
    [:i18n :customer-conflict/text]]
   [:button {:class button/button-primary-css
             :on {:click [[:ui/modal-close]
                          [:crisp/set-message-text [:i18n :customer-conflict/support-message]]
                          [:crisp/open-chat]]}}
    [:i18n :customer-conflict/chat]]])

(defn render
  "Modals render outside `ui.wallet.page/render`, so the modal has to
   translate itself."
  [w]
  (i18n/translate w (content)))

(def modal
  {:modal-id modal-id
   :render #'render})
